import React from 'react'
import {
  BookingCardBookCardContainer,
  BookingCardCardImg,
  BookingCardCardTitle,
  BookingCardCircle,
  BookingCardCircleInner,
  BookingCardGap
} from './style'

interface BuyerPaymentMethodOptionProps {
  img: string;
  id: string;
  cardInfo: string;
  isSelect: boolean;
  setIsSelect: (id: string) => void;
}

const BuyerPaymentMethodOption = ({ img, id, cardInfo, isSelect, setIsSelect }: BuyerPaymentMethodOptionProps) => {

  return (
    <BookingCardBookCardContainer onClick={() => setIsSelect(id)}>
    <BookingCardGap container alignItems='center'>
      <BookingCardCardImg src={img} alt="Payment Card" />
      <BookingCardCardTitle>{cardInfo}</BookingCardCardTitle>
    </BookingCardGap>
    <BookingCardCircle>
      {isSelect && <BookingCardCircleInner />}
    </BookingCardCircle>
    </BookingCardBookCardContainer>
  )
}

export default BuyerPaymentMethodOption
